(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-detail"] && !Shopify.designMode) return;
  try {
    
  class ImageDetail extends HTMLElement {
    constructor() {
      super();

      this.headings = this.querySelectorAll('.heading');
      this.headings.forEach((heading, index) => {
        heading.insertAdjacentHTML(
          'beforebegin',
          `<span class="image-detail__heading-index rounded-full bg-primary text-primary-text size-[3ch] absolute -top-1 -left-10 text-center leading-[3ch]">${index + 1}</span>`
        );
      });
    }
  }
  if (!customElements.get('image-detail')) {
    customElements.define('image-detail', ImageDetail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.fixedClass = 'is-fixed';
      this.quickAddWrapper = Array.from(this.querySelectorAll('[data-product-form]')).filter((wrapper) => wrapper.classList.contains(this.fixedClass));
      this.quickAddContent = this.quickAddWrapper[0].querySelector('[data-product-form-inner]');

      // On scroll, observe the product form on mobile and make it fixed when necessary
      this.debouncedOnScroll = debounce((event) => {
        document.body.style.paddingBottom = `${this.quickAddContent.clientHeight}px`;
      }, 10);

      window.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      window.addEventListener('resize', this.debouncedOnScroll.bind(this));
    }
  }
  if (!customElements.get('product-info')) {
    customElements.define('product-info', ProductInfo);
  }

  } catch(e) { console.error(e); }
})();
})();
